import * as React from 'react';

import usePublicTranslation from '@/hooks/usePublicTranslation';
import useReadingTimeCalculator from '@/hooks/useReadingTimeCalculator';
import { formatUnixTimestamp } from '@/utils/date';

import { usePageContext } from '../../../context';

type PageTitleProps = {
  includeCreationDate: boolean;
  includeReadingTime: boolean;
  [key: string]: unknown;
};
const PageTitle: React.FC<PageTitleProps> = ({ includeCreationDate, includeReadingTime, ...props }) => {
  const t = usePublicTranslation();

  const { title, createdOn, rawBody } = usePageContext();
  const { readingTime } = useReadingTimeCalculator({
    content: rawBody || ''
  });

  return (
    <div {...props}>
      <h1>{title}</h1>
      {(includeCreationDate || includeReadingTime) && (
        <div className="wp-block-erom-page-title-meta">
          {includeCreationDate && createdOn && (
            <span className="wp-block-erom-page-title-creation-date">
              {formatUnixTimestamp(createdOn, 'MMMM DD, YYYY')}
            </span>
          )}
          {includeCreationDate && includeReadingTime && (
            <span className="wp-block-erom-page-title-meta-separator">/</span>
          )}
          {includeReadingTime && (
            <span className="wp-block-erom-page-title-reading-time">
              {t('page.reading_time', { time: readingTime || t('general.na') })}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default PageTitle;
